module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_decherney_sm-c7000a65538989623d1547f14b70d0b1.png";